module.exports = __webpack_public_path__ + "static/auto-icon-98x148-e55aeeb30e19ad96f701c721cd1998bc.png";